import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Page_settings } from "@/config/page_settings";
import { useNavigate } from "react-router-dom";
import { API_URL, RESULT_CODE } from "@/config/const";

const BillConfirmPage = () => {
  /* **********************************
    * GLOBAL STATE
    * 전역 상태 및 전역 변수
    ********************************** */
  const navigate = useNavigate();
  const context: any = useContext(Page_settings);
  //const [data, setData] = useState(null);

  const [chewingplusKey, setChewingplusKey] = useState("");
  const [approvalAmount, setApprovalAmount] = useState("0");
  const [mobileNo, setMobileNo] = useState("010");
  

  useEffect(() => {
    //결제요청 메시지에서 츄잉플러스 요청키 값 가져오기(ex:payKey)
    const params = new URLSearchParams(window.location.search);
    const chewingplusKey = params.get('chewingplusKey'); // "12345678"    
    const mobileNo = params.get('mobileNo'); 
    
    
    setChewingplusKey(chewingplusKey);
    setApprovalAmount("1004");
    setMobileNo(mobileNo);

    
  }, []); 

  //츄잉플러스 결제서비스 호출
  const goChewingplusPaymentPage = () => {
    context.post(
      `/chewingplus/payTestRequest`,  //츄잉플러스 URL  /platform/payTestRequest
      {
        chewingplusKey: chewingplusKey,
        approvalAmount: approvalAmount,
        mobileNo: mobileNo,
      },
      (response) => {
        console.log(response);
        //setData(response); // 상태에 JSON 데이터 할당
        goPaymentPage(response);
      }
    );
  };

  //츄잉페이 결제서비스 호출
  const goPaymentPage = (data) => {
    context.post(
      '/api/requestPayment',
      data,
      (response) => {
        if(response.RESULT_CODE === "0000"){
          //alert(response.REDIRECT_URL);
          console.log(response.REDIRECT_URL);
          window.location.href = response.REDIRECT_URL;
        }else{
          //요청실패
          alert(response.RESULT_CODE);
          alert(response.RESULT_MSG);
        }
      }
    );
  };

  return (
    <div>
      <h3>카리페이 결제요청(수동테스트)</h3>
       <div>
         <label>거래고유번호(TRANS_SEQNO): </label>
         <input
           type="text"
           name="chewingplusKey"
           value={chewingplusKey}
           onChange={(e) => setChewingplusKey(e.target.value)}
         />
       </div>
       <div>
         <label>총결제금액(APPROVAL_AMOUNT): </label>
         <input
           type="number"
           name="APPROVAL_AMOUNT"
           value={approvalAmount}
           onChange={(e) => setApprovalAmount(e.target.value)}
         />
       </div>
       <div>
         <label>모바일번호('-'없이입력): </label>
         <input
           type="number"
           name="MOBILE_NO"
           value={mobileNo}
           onChange={(e) => setMobileNo(e.target.value)}
         />
       </div>
      <button onClick={goChewingplusPaymentPage}>결제요청</button>
    </div>
  );
}

export default BillConfirmPage;